import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";

import CustomNavbar from "../../components/CustomNavbar";
import CustomFooter from "../../components/CustomFooter";
import ShowInfo from "../../components/ShowInfo";
import MainContentSpaced from "../../components/MainContentSpaced";

import api from "../../service/api";
import { TOKEN_USERTYPE, TOKEN_BRANCHID } from "../../service/tokens";

const TabloidBackgroundCreate = (props) => {
    const [showTrips, setShowTrips] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertText, setAlertText] = useState("");
    const [alertVariant, setAlertVariant] = useState("");
    const [backgroundName, setBackgroundName] = useState(null);
    const [file, setFile] = useState(null);

    function handleSubmit(e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("background", file);
        formData.append("name", backgroundName);
    
        async function createNewBackground() {
            const responseCreateNewBackground = await api.post("/background/create", formData);

            if (
                responseCreateNewBackground.data.error ||
                responseCreateNewBackground.status === 500
            ) {
                setShowAlert(true);
                setAlertTitle("Problemas ao criar a fundo.");
                setAlertText(
                    `Tivemos problemas ao tentar criar a fundo. Por favor contate o suporte!`
                );
                setAlertVariant("danger");
            } else {
                setShowAlert(true);
                setAlertTitle("Fundo criado com sucesso!");
                setAlertText(
                    `Voce sera automaticamente direcionado para a lista`
                );
                setAlertVariant("success");

                setTimeout(() => {
                    props.history.push("/background-list");
                }, 5000);
            }
        }

        createNewBackground();
    }

    return (
        <>
            <CustomNavbar />
            <MainContentSpaced>
                <Container>
                    <Row>
                        <Col>
                            <ShowInfo
                                title={alertTitle}
                                text={alertText}
                                show={showAlert}
                                variant={alertVariant}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="formAd">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Nome"
                                        value={backgroundName}
                                        onChange={(e) => {
                                            setBackgroundName(e.target.value);
                                        }}
                                    />
                                    <Form.Text className="text-muted">
                                        Digite o nome desejado para o Fundo.
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group controlId="formFile">
                                    <Form.Label>Imagem</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={(e) => {
                                            setFile(e.target.files[0]);
                                        }}
                                    />
                                    <Form.Text className="text-muted">
                                        Escolha a imagem correta de fundo.
                                    </Form.Text>
                                </Form.Group>

                                <Button variant="success" type="submit">
                                    Criar!
                                </Button>
                            </Form>
                        </Col>
                        {showTrips ? (
                            <Col>
                                <Card>
                                    <Card.Header>Dicas</Card.Header>
                                    <Card.Body>
                                        <Card.Title>
                                            Use essas dicas durante o cadastro:
                                        </Card.Title>
                                        <Card.Text>
                                            <ul className="list-unstyled">
                                                <li>
                                                    - Digite o nome desejado
                                                    para o Fundo
                                                </li>
                                                <li>
                                                    - Verifique se a imagem esta correta
                                                </li>
                                            </ul>
                                        </Card.Text>
                                        <Button
                                            variant="warning"
                                            onClick={() => setShowTrips(false)}
                                        >
                                            Não quero mais ver as dicas!
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ) : null}
                    </Row>
                </Container>
            </MainContentSpaced>
            <CustomFooter />
        </>
    );
};

export default withRouter(TabloidBackgroundCreate);
